import * as types from '../constants/actionTypes';

export const createPaymentRequest = (data) => ({
  type: types.CREATE_PAYMENT_REQUEST,
  payload: data,
});

export const createPaymentSuccess = (data) => ({
  type: types.CREATE_PAYMENT_SUCCESS,
  payload: data,
});

export const createPaymentFailure = (error) => ({
  type: types.CREATE_PAYMENT_FAILURE,
  payload: error,
});

export const fetchBillPaymentsRequest = (billId) => ({
  type: types.FETCH_BILL_PAYMENTS_REQUEST,
  payload: billId,
});

export const fetchBillPaymentsSuccess = (billId, data) => ({
  type: types.FETCH_BILL_PAYMENTS_SUCCESS,
  payload: { billId, data },
});

export const fetchBillPaymentsFailure = (error) => ({
  type: types.FETCH_BILL_PAYMENTS_FAILURE,
  payload: error,
});

export const fetchBillPaymentSummaryRequest = (billId) => ({
  type: types.FETCH_BILL_PAYMENT_SUMMARY_REQUEST,
  payload: billId,
});

export const fetchBillPaymentSummarySuccess = (billId, data) => ({
  type: types.FETCH_BILL_PAYMENT_SUMMARY_SUCCESS,
  payload: { billId, data },
});

export const fetchBillPaymentSummaryFailure = (error) => ({
  type: types.FETCH_BILL_PAYMENT_SUMMARY_FAILURE,
  payload: error,
});

export const fetchAllPaymentsRequest = (params = {}) => ({
  type: types.FETCH_ALL_PAYMENTS_REQUEST,
  payload: params,
});

export const fetchAllPaymentsSuccess = (data) => ({
  type: types.FETCH_ALL_PAYMENTS_SUCCESS,
  payload: data,
});

export const fetchAllPaymentsFailure = (error) => ({
  type: types.FETCH_ALL_PAYMENTS_FAILURE,
  payload: error,
});

export const fetchPaymentStatisticsRequest = (params = {}) => ({
  type: types.FETCH_PAYMENT_STATISTICS_REQUEST,
  payload: params,
});

export const fetchPaymentStatisticsSuccess = (data) => ({
  type: types.FETCH_PAYMENT_STATISTICS_SUCCESS,
  payload: data,
});

export const fetchPaymentStatisticsFailure = (error) => ({
  type: types.FETCH_PAYMENT_STATISTICS_FAILURE,
  payload: error,
});

export const clearPaymentError = () => ({
  type: types.CLEAR_PAYMENT_ERROR,
});
